const ErrorView = () => import(/* webpackChunkName: "Error" */ "@/views/errors/Error");

const errorsRoutes = [
  {
    path: "/error",
    name: "Error",
    component: ErrorView,
    meta: {
      isPublic: true
    }
  }
];

export default errorsRoutes;